import { BasePagePath } from "app/core/workflow/page-path/base-page.path";
import { PathParamKeys } from "app/core/workflow/page-path/path-param-keys";

export class NewsletterResignationInfoPath extends BasePagePath {
  public static path(): string {
    return `accounts/newsletter/:${PathParamKeys.activationKey}`;
  }

  public static get defaultPathParamRegex(): string {
    return "\(\[a-z\]\|\[0-9\]\)+";
  }
}
